import '../../App.scss';
import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom'



class Button extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);
   
    this.state = {
      isHovered: false
    };

    // This binding is necessary to make `this` work in the callback
    this.handleHover = this.handleHover.bind(this);
  }

  handleHover = () => this.setState({ isHovered: !this.state.isHovered });

 
  render() {
    const { width, height, cx, content, rotated, label, icon, hasIcon, link, externalLink } = this.props;

    // console.log(externalLink)
    const goToLink = externalLink ? { pathname: externalLink } : {pathname: link}
    const linkTarget = externalLink ? '_blank' : '_self'


    return (
      
      <Link aria-label={label} to={goToLink} target={linkTarget} className={`w-${width} h-${height} ${cx} hover-animation ${this.state.isHovered ? "bg-hover " : ""} `} onMouseEnter={this.handleHover} onMouseLeave={this.handleHover}>
        <span className={rotated ? 'rotate-90-center pos-absolute top-50 left-50 max-content' : ''}>
        {hasIcon ? (<p className="ta-center margin-t-0 margin-b-0 icon-size">{icon}</p>) : ('')} {content}
        </span>
      </Link>
      
    );
  }
}


export default Button;